var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "demo" },
    _vm._l(_vm.demoList, function(item, index) {
      return _c(
        "div",
        { key: index, staticClass: "demo-body" },
        [
          _c("XHighlight", {
            staticClass: "x-highlight",
            attrs: {
              title: item.title,
              lang: item.lang,
              show: item.show,
              tool: item.tool,
              maxHeight: item.maxHeight,
              locale: item.locale,
              data: item.data
            }
          })
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ab7d1f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab7d1f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/components/Demo.vue
// module id = null
// module chunks = 